export const DEFAULT_TABLE_TITLE_WIDTH = 120;
